var _defs, _path, _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Help",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      #Help .cls-1 {\n        fill: #00c4ff;\n      }\n\n      #Help .cls-2 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_174",
    "data-name": "Pfad 174",
    className: "cls-1",
    d: "M16,2A14,14,0,1,1,2,16,14.041,14.041,0,0,1,16,2m0-2A16,16,0,1,0,32,16,15.983,15.983,0,0,0,16,0Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_435",
    "data-name": "Ellipse 435",
    className: "cls-1",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1 1)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_87",
    "data-name": "Gruppe 87",
    transform: "translate(10.7 5.8)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_47",
    "data-name": "Rechteck 47",
    className: "cls-2",
    width: 3.2,
    height: 3.2,
    transform: "translate(3.2 15.8)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_175",
    "data-name": "Pfad 175",
    className: "cls-2",
    d: "M20.8,7.3a6,6,0,0,0-4.2-1.5,12.027,12.027,0,0,0-4,.6c-.5.2-1.9.7-1.9,1.8v2.9h3l.1-.4V9.5a1.541,1.541,0,0,1,.7-.3A4.678,4.678,0,0,1,16.2,9a2.817,2.817,0,0,1,2.1.7,2.342,2.342,0,0,1,.8,1.8c0,1-.9,1.8-2.5,2.6a6.658,6.658,0,0,0-1.2.6,2.707,2.707,0,0,0-1.1,1,3.339,3.339,0,0,0-.3,1.5v3.4h2.7l.5.1V17.3A11.41,11.41,0,0,0,21.1,15a4.534,4.534,0,0,0,1.4-3.3A6.1,6.1,0,0,0,20.8,7.3Z",
    transform: "translate(-10.7 -5.8)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelper);
export default __webpack_public_path__ + "static/media/helper.b1429882519adfa3dd76b4e4e264aa94.svg";
export { ForwardRef as ReactComponent };